module.exports = __webpack_public_path__ + "img/elektron.4c9d4c53.png";